/**
 * Nigeria's 36 states + FCT, with the 2-letter codes shipping-zones (PE-2172/PE-2173)
 * expects in `stateOrProvinceCodes` (backend example: `LA` = Lagos). No official
 * ISO 3166-2 standard uses 2-letter Nigerian subdivision codes, so these are the
 * platform's own convention — keep them in sync with logistics-service if it ever
 * starts validating them server-side.
 */
export interface NigerianState {
  code: string;
  name: string;
}

export const NIGERIAN_STATES: NigerianState[] = [
  { code: 'AB', name: 'Abia' },
  { code: 'AD', name: 'Adamawa' },
  { code: 'AK', name: 'Akwa Ibom' },
  { code: 'AN', name: 'Anambra' },
  { code: 'BA', name: 'Bauchi' },
  { code: 'BY', name: 'Bayelsa' },
  { code: 'BE', name: 'Benue' },
  { code: 'BO', name: 'Borno' },
  { code: 'CR', name: 'Cross River' },
  { code: 'DE', name: 'Delta' },
  { code: 'EB', name: 'Ebonyi' },
  { code: 'ED', name: 'Edo' },
  { code: 'EK', name: 'Ekiti' },
  { code: 'EN', name: 'Enugu' },
  { code: 'FC', name: 'Federal Capital Territory' },
  { code: 'GO', name: 'Gombe' },
  { code: 'IM', name: 'Imo' },
  { code: 'JI', name: 'Jigawa' },
  { code: 'KD', name: 'Kaduna' },
  { code: 'KN', name: 'Kano' },
  { code: 'KT', name: 'Katsina' },
  { code: 'KE', name: 'Kebbi' },
  { code: 'KO', name: 'Kogi' },
  { code: 'KW', name: 'Kwara' },
  { code: 'LA', name: 'Lagos' },
  { code: 'NA', name: 'Nasarawa' },
  { code: 'NI', name: 'Niger' },
  { code: 'OG', name: 'Ogun' },
  { code: 'ON', name: 'Ondo' },
  { code: 'OS', name: 'Osun' },
  { code: 'OY', name: 'Oyo' },
  { code: 'PL', name: 'Plateau' },
  { code: 'RI', name: 'Rivers' },
  { code: 'SO', name: 'Sokoto' },
  { code: 'TA', name: 'Taraba' },
  { code: 'YO', name: 'Yobe' },
  { code: 'ZA', name: 'Zamfara' },
];

/** Shaped for the shared `Select` component's `options` prop ({title, value}[]). */
export const NG_STATE_OPTIONS = NIGERIAN_STATES.map((s) => ({ title: s.name, value: s.code }));

const NAME_BY_CODE = new Map(NIGERIAN_STATES.map((s) => [s.code, s.name]));

/** Falls back to the raw code so an unrecognised value still renders something. */
export const nigerianStateName = (code: string): string => NAME_BY_CODE.get(code) ?? code;
